import styles from '@components/components/CmsComponents/components/CmsFactBox/CmsFactBox.module.scss';
import React from 'react';
import { FactBox } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const CmsFactBox = ({ headingLevel, slides, hasBackground }) => (
  <div
    className={classNames(styles.container, {
      [styles.hasBackground]: hasBackground,
    })}
  >
    <FactBox headingLevel={headingLevel} slides={slides} />
  </div>
);

export default CmsFactBox;
